import React, { useEffect, useState } from "react";
import { ReactComponent as AngleUp } from 'assets/icons/angle-up.svg';
import { ReactComponent as AngleDown } from 'assets/icons/angle-down.svg';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { StandartButton } from "commons/form-controls";
import { InputCheckBox } from "commons/input-controls";
import s from "./feed-settings.module.scss";

const FeedSettings = (props) => {
    const getIsFeedSettingsLink = (link) => {
        if(props.parameters && props.parameters.FEED_SETTINGS && props.parameters.FEED_SETTINGS.linkElements){
            if(props.parameters.FEED_SETTINGS.linkElements.indexOf(link) !== -1){
                return true
            }
            else return false
        }
        else return false
    }

    const [parameters, setParameters] = useState(props.parameters);
    const [feedSettings, setFeedSettings] = useState(props.feedSettings);
    const [isOpened, setIsOpened] = useState(false);
    const [titleLink, setTitleLink] = useState(getIsFeedSettingsLink('DOCUMENT_TITLE'));
    const [domainLink, setDomainLink] = useState(getIsFeedSettingsLink('DOCUMENT_DOMAIN'));
    const [dateLink, setDateLink] = useState(getIsFeedSettingsLink('DOCUMENT_DATE'));

    useEffect(() => {
        setParameters(props.parameters);
        setTitleLink(getIsFeedSettingsLink('DOCUMENT_TITLE'));
        setDomainLink(getIsFeedSettingsLink('DOCUMENT_DOMAIN'));
        setDateLink(getIsFeedSettingsLink('DOCUMENT_DATE'));
    }, [props])

    const setIsOpenedItem = () => {
        setIsOpened(!isOpened)
    }

    const addSettings = () => {
        let params = parameters;
        params.FEED_SETTINGS = props.feedSettings;
        props.updateFeedSettings(params)
    }

    const removeSettings = () => {
        let params = parameters
        delete params.FEED_SETTINGS;
        props.updateFeedSettings(params);
    }

    const setDocumentGapToSettings = (isChecked, type) => {
        let params = parameters;
        let feedSettings = parameters.FEED_SETTINGS;
        feedSettings[type] = isChecked;
        params.FEED_SETTINGS = feedSettings;
        props.updateFeedSettings(params);
    }

    const setToDocumentTitleDoamin = (isChecked, type) => {
        let params = parameters;
        let feedSettings = parameters.FEED_SETTINGS;
        //let isDomain = feedSettings.documentTitle.indexOf("DOMAIN");
        if(isChecked){
            feedSettings.documentTitle = ["DOMAIN", "TITLE"];
        }
        else feedSettings.documentTitle = ["TITLE"];
        params.FEED_SETTINGS = feedSettings;
        props.updateFeedSettings(params);
    }

    const setFeedSettingLink = (isPressed, link) => {
        if(!parameters.FEED_SETTINGS.linkElements){
            parameters.FEED_SETTINGS.linkElements = [];
        }
        let params = parameters;
        let feedSettings = parameters.FEED_SETTINGS;
        let isLink = feedSettings.linkElements.indexOf(link)
        if(isLink === -1)
            feedSettings.linkElements.push(link);
        else
            feedSettings.linkElements.splice(isLink, 1);
        params.FEED_SETTINGS = feedSettings;
        props.updateFeedSettings(params)

    }

    let docTitle = parameters.FEED_SETTINGS && parameters.FEED_SETTINGS.documentTitle && parameters.FEED_SETTINGS.documentTitle.length && parameters.FEED_SETTINGS.documentTitle.indexOf("DOMAIN") !== -1 ? true : false;

    return (
        <div className={s.FeedSettings}>
            <div className={s.FeedSettingsHeader} onClick={setIsOpenedItem}>
                <span>{props.getValue('SET_FEED_SETTINGS')}</span>
                <div className={s.headersButtonsBlock}>
                    <StandartButton background={'white'} icon={isOpened ? AngleDown : AngleUp } />
                        {parameters.FEED_SETTINGS 
                            ? (!props.readOnly 
                                            ? <StandartButton icon={CloseIcon} background={'white'} callback={removeSettings}/> 
                                            : null )
                            : (!props.readOnly 
                                            ? <StandartButton icon={PlusIcon} background={'white'} callback={addSettings}/> 
                                            : null )
                            }
                </div>
            </div>
            { isOpened && parameters && parameters.FEED_SETTINGS ? <div className={s.FontBaseBody}>
                <div className="formRow">
                    <div className="labelText">
                        <span>{props.getValue('SPACE_BETWEEN_PUBLICATIONS')}</span>
                        <InputCheckBox isDisabled={props.isReadOnly} isChecked={parameters.FEED_SETTINGS.documentGap} name={"documentGap"} callback={setDocumentGapToSettings} title={props.getValue("ALL_ON_PAGE")} />
                    </div>
                    
                </div>
                <div className="formRow">
                    <div className="labelText">
                        <span>{props.getValue('SHOW_ICONS_IN_DOCUMENT')}</span>
                        <InputCheckBox isDisabled={props.isReadOnly} isChecked={parameters.FEED_SETTINGS.icons} name={"icons"} callback={setDocumentGapToSettings} title={props.getValue("ALL_ON_PAGE")} />
                    </div>
                </div>
                <div className="formRow">
                <div className="labelText">
                    <span>{props.getValue('SOURCE_IN_PUBLICATION_TITLE')}</span>
                    <InputCheckBox isDisabled={props.isReadOnly} isChecked={docTitle} name={"documentTitle"} callback={setToDocumentTitleDoamin} title={props.getValue("ALL_ON_PAGE")} />
                </div>
            </div>
                <div className="formRow">
                    <div className="labelText">
                        <span>{props.getValue('LINK_ON_DOCUMENT_TITLE')}</span>
                        <InputCheckBox isDisabled={props.isReadOnly} isChecked={titleLink} name={"DOCUMENT_TITLE"} callback={setFeedSettingLink} title={props.getValue("ALL_ON_PAGE")} />
                    </div>
                </div>
                <div className="formRow">
                    <div className="labelText">
                        <span>{props.getValue('LINK_ON_DOCUMENT_DOMAIN')}</span>
                        <InputCheckBox isDisabled={props.isReadOnly} isChecked={domainLink} name={"DOCUMENT_DOMAIN"} callback={setFeedSettingLink} title={props.getValue("ALL_ON_PAGE")} />
                    </div>
                </div>
                <div className="formRow">
                    <div className="labelText">
                        <span>{props.getValue('LINK_ON_DOCUMENT_DATE')}</span>
                        <InputCheckBox isDisabled={props.isReadOnly} isChecked={dateLink} name={"DOCUMENT_DATE"} callback={setFeedSettingLink} title={props.getValue("ALL_ON_PAGE")} />
                    </div>
                </div>
                
            </div> : null }
        </div>
    )
}

export default FeedSettings;